import { useTranslation, Trans } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Header, Navbar, Footer } from "../components";
import ErrorPage from "./ErrorPage";
import customAxios from "../utils/customAxios";

import { styles } from "../styles";

const SejarahPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["histories"],
    queryFn: async () => {
      const response = await customAxios.get("histories");

      return response?.data?.data || null;
    },
    staleTime: 1000 * 60 * 5,
    keepPreviousData: true, // Keeps current table data visible while fetching the next page/filter
    refetchOnWindowFocus: false,
  });

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const renderContent = () => {
    if (isLoading) {
      return (
        <>
          {[...Array(3)].map((_, index) => (
            <div key={index} className="relative flex items-center w-full gap-8 p-5 mt-5 bg-gray-200 h-44 group sm:flex-col-reverse even:flex-row-reverse animate-pulse">
              <div className="my-1 border w-[20%] h-[42px] bg-gray-300 absolute top-[-21px] left-5 group-even:left-auto group-even:right-5 flex items-center flex-col justify-center"></div>
            </div>
          ))}
        </>
      );
    }

    if (!data) return null;

    return (
      <>
        {data?.map(({ id, year, description_id, description_en, image }) => (
          <div
            key={id}
            className="relative flex items-center w-full gap-8 p-5 mt-5 border-2 group border-neutral-50 sm:flex-col-reverse even:flex-row-reverse"
          >
            <div className="my-1 border w-[20%] h-[42px] bg-primary-40 absolute top-[-21px] left-5 group-even:left-auto group-even:right-5 flex items-center flex-col justify-center">
              <p className={`${styles.headingMS}  text-neutral-10 text-center`}>
                {year}
              </p>
            </div>

            <p className={`${styles.textLRegularM} h-fit`}>
              {currentLanguage === "en" ? description_en : description_id}
            </p>

            <img
              className="w-[190px] sm:w-[150px]"
              src={image}
              alt="University Logo"
            />
          </div>
        ))}
      </>
    );
  };

  return (
    <>
      <Navbar />
      <Header title={t("history.header")} />

      <main className={`${styles.paddingX} flex flex-col py-20 items-center min-h-[600px]`}>
        <div className="max-w-[750px] w-full flex flex-col items-center">
          <h1 className={`${styles.headingLM}  text-primary-40`}>
            <Trans i18nKey="history.title" />
          </h1>
          <h2 className={`${styles.headingSM} text-center`}>
            <Trans i18nKey="history.subtitle" />
          </h2>

          <div className="flex flex-col items-center w-full gap-8 pt-14">
            {renderContent()}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default SejarahPage;
